import { render, staticRenderFns } from "./BenefitsOfBeingPartner.vue?vue&type=template&id=83aaa97a&scoped=true"
import script from "./BenefitsOfBeingPartner.vue?vue&type=script&lang=js"
export * from "./BenefitsOfBeingPartner.vue?vue&type=script&lang=js"
import style0 from "./BenefitsOfBeingPartner.vue?vue&type=style&index=0&id=83aaa97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aaa97a",
  null
  
)

export default component.exports